<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-full mt-2">
                            <label class="vs-input--label">Tên bài kiểm tra</label>
                            <vs-input class="w-full" v-model="schoolQuizName" type="text" data-vv-validate-on="blur" />
                        </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                        :options="organizationBranchOptions" @input="changeData">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.classRoom') }}</label>
                    <v-select class="" v-model="classRoomModel" :clearable="false" :options="classRoomOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.student') }}</label>
                    <v-select class="" v-model="selectedStudent" :clearable="false" :options="studentOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('multipleChoice.category') }}</label>
                    <v-select class="" v-model="selectCategory" :options="categoryOptionsSearch" :clearable="false"
                              :reduce="(option) => option.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-2">
                    <label class="vs-input--label">{{ $t('attendance.times') }}</label>
                    <div class="flex-grow">
                        <date-range-picker class="w-full" ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }"
                            :opens="'right'" @update="dateRangePicker" v-model="dateRange">
                        </date-range-picker>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-2">
                <vs-button class="mt-4 mr-4" @click="filter" :disabled="!validateForm" icon="icon-search"
                    icon-pack="feather">{{ $t('attendance.filter') }}
                </vs-button>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh" ref="agGridTable" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="dataStudentWorkHistory" :animateRows="true"
                :localeText="{ noRowsToShow: this.$t('menuCamera.noRowsToShow') }" paginationPageSize="20"
                :pagination="true"  @grid-ready="onGridReady"
                :autoSizeStrategy="autoSizeStrategy" tooltipShowDelay="0" tooltipHideDelay="5000"
                :tooltipMouseTrack="true">
            </ag-grid-vue>

            <div class="vx-row">
                <div class="w-full flex">
                    <div style="min-width:200px">
                        <span class="content-page font-bold ml-4">{{ $t('dashboard.display') }}: </span><span
                            class="text-page">{{
                        countElementPage > totalElements ? totalElements : countElementPage
                    }} /
                            {{ totalElements }} </span>
                    </div>
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import authConfig from '@/../auth_config.json';
import moment from 'moment'; // Vuesax
import Pagination from "../../ui-elements/Pagination.vue"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        Datepicker,
        Pagination,
        DateRangePicker,
        flatPickr
    },
    data() {
        return {
            schoolQuizName:null,
            classId: null,
            classRoomOptions: [],
            gridApi: null,
            defaultColDef: {},
            dataStudentWorkHistory:[],
            columnDefs: [
            {
                    headerName: this.$t('multipleChoice.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: 'Tên bài kiểm tra',
                    field: 'schoolQuizName',
                    width: 300,
                },
                {
                    headerName: 'Danh mục',
                    field: 'categoryName',
                    width: 250
                },
                {
                    headerName: 'Học sinh',
                    field: 'studentName',
                    width: 250
                },
                {
                    headerName: 'Thời gian làm bài',
                    field: 'duration',
                    width: 200
                },
                {
                    headerName: 'Điểm',
                    field: 'points',
                    width: 150
                },
                {
                    headerName: this.$t('multipleChoice.createDate'),
                    field: 'startDateQuiz',
                    width: 250
                },
                {
                    headerName: 'Thời gian bắt đầu làm',
                    field: 'startDate',
                    width: 250
                },
            ],
            selectCategory:null,
            categoryOptionsSearch:[{value:null , label: this.$t('multipleChoice.all')}],
            shiftTypeModel: { value: null, label: 'Tất cả' },
            studentData: [],
            organizationBranchOptions: [],
            studentOptions: [
                { value: null, label: this.$t('menuOrganization.all') }
            ],
            selectedOrganizationBranchValue: null,
            selectedStudentValue: null,
            dateRange: {
                endDate: null,
                startDate: null,
            },
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
            pageNumber: 0,
            pageSize: 20,
        }
    },
    created() {
        this.initScreen()
    },
    computed: {
        classRoomModel: {
            get() {
                let object = this.classRoomOptions.find(el => el.value == this.classId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            async set(object) {
                this.classId = object ? object.value : null;
                await this.loadStudent();
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null
                await this.loadStudent();
            }
        },
        selectedStudent: {
            get() {
                return {
                    label: this.employeeString(this.selectedStudentValue),
                    value: this.selectedStudentValue
                }
            },
            set(obj) {
                this.selectedStudentValue = obj.value
            }
        },
    },
    methods: {
        changeData() {
            this.getClassRoom()
        },
        getClassRoom() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    organizationId: userInfo.organization.id,
                    status: true
                }
                this.$vs.loading()
                this.$crm.post('/school-classroom/get-all-class', payload).then((res) => {
                    this.classRoomOptions = res.data.map(el => {
                        return {
                            label: el.className,
                            value: el.id
                        }
                    });
                    this.classRoomOptions.unshift({ label: 'Tất cả', value: null });
                    resolve()
                    this.$vs.loading.close()
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        getCategory() {
            return new Promise((resolve, reject) => {
                let body = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,

                }
                this.$crm.post('/school-quiz-category/find-by-condition', body).then((response) => {
                    this.categoryOptionsSearch  = response.data.content.map(el => {
                        return {
                            label: el.categoryName,
                            value: el.id
                        }
                    })
                    this.categoryOptionsSearch.unshift({value:null, label:'Tất cả'})
                    resolve(response)
                }).catch((err) => {
                    reject(response);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })

        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'Chưa xác định';
        },
        employeeString(id) {
            let student = this.studentOptions.find(x => x.value === id);
            return (student && student.label) || 'Chưa xác định';
        },
        validateForm() {
            return !this.errors.any()
        },
        filter() {
            return new Promise((resolve, reject) => {
                let body = {
                    organizationBranchId:this.selectedOrganizationBranch.value,
                    schoolQuizName:this.schoolQuizName,
                    classId:this.classRoomModel.value,
                    categoryId:this.selectCategory,
                    createDate:this.dateRange.startDate,
                    endCreateDate:this.dateRange.endDate,
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,

                }
                this.$vs.loading();
                this.$crm.post('/school-quiz/find-by-condition-result', body).then((response) => {
                    this.dataStudentWorkHistory = response.data.content.map(el => {
                    el.stt = response.data.content.indexOf(el) + 1;
                    el.startDate = el.startDate ? moment(el.startDate).format('DD/MM/YYYY HH:mm') : '';
                    el.startDateQuiz = el.startDateQuiz ? moment(el.startDateQuiz).format('DD/MM/YYYY HH:mm') : 'Chưa làm bài';
                    el.duration = el.duration + ' Phút'
                    if(this.categoryOptionsSearch){
                        this.categoryOptionsSearch.map( t => {
                            if (t.value === el.categoryId){
                                 el.categoryName = t.label
                            }
                        })
                    }
                    if(this.studentOptions){
                        this.studentOptions.map( t => {
                            if (t.value === el.studentId){
                                 el.studentName = t.label
                            }
                        })
                    }
                    return el;
                })
                    this.countElementPage = this.dataStudentWorkHistory.length;
                    this.totalElements = response.data.totalElements;
                    this.totalPages = response.data.totalPages
                    resolve(response)
                    setTimeout( () => {
                        this.$vs.loading.close();
                    },100)
                   
                }).catch((err) => {
                    reject(response);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

 
        loadPage: function (currentPage) {
            if (parseInt(currentPage) - 1 != this.pageNumber) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.filter();
            }
        },
        async initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.filter(x => x.organizationBranchType === 3).map(item => {
                return { value: item.id, label: item.organizationBranchName }
            })
            this.organizationBranchOptions.unshift({ value: null, label: this.$t('menuOrganization.all') })
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
                this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            }
            await this.getClassRoom();
            await this.loadStudent()
            await this.getCategory()
            await this.filter();
        },
        loadStudent() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                let schoolStudentSearchDTO = {
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    organizationId: userInfo.organization.id,
                    enabled: true,
                    pageNumber: 1,
                    pageSize: 1000,
                    sort: 'id',
                    classId: this.classId
                }
                this.$crm.post('/school-student/find-by-condition', schoolStudentSearchDTO).then((response) => {
                    this.studentData = response.data.content;
                    this.studentOptions = response.data.content.map(item => {
                        return {
                            value: item.id,
                            label: item.fullName,
                        }
                    });
                    if (this.studentOptions.length > 0 && this.selectedStudentValue) {
                        let employee = this.studentOptions.find(x => x.value == this.selectedStudentValue);
                        this.selectedStudent = employee;
                    }
                    this.studentOptions.unshift({ value: null, label: this.$t('menuOrganization.all') })
                    setTimeout(() => {
                        this.gridApi.sizeColumnsToFit();
                    }, 180);
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
